export const HELP_CONTENT = {
  dashboard: {
    activeChats: {
      title: "Active Chats",
      content: "Live conversations currently being handled by agents. These require immediate attention and are actively being responded to."
    },
    waiting: {
      title: "Waiting Conversations",
      content: "Customers waiting for an agent response. Click 'Take Over' to assign yourself to any conversation."
    },
    agentsOnline: {
      title: "Agents Online",
      content: "Team members currently available to handle customer conversations. Agents are marked online when they're actively using the dashboard."
    },
    todaysTotal: {
      title: "Today's Conversations",
      content: "Total number of conversations handled today across all agents and channels."
    },
    todaysAppointments: {
      title: "Today's Appointments",
      content: "Number of appointments scheduled for today. Reminders are sent automatically based on your settings."
    },
    conversationsTab: {
      title: "Conversations Management",
      content: "View and manage all customer conversations in one place. Click any conversation to view the full message history and respond."
    },
    calendarTab: {
      title: "Appointment Calendar",
      content: "Schedule and manage customer appointments. Automatic reminders are sent to both customers and agents based on your configuration."
    },
    crmTab: {
      title: "Customer Relationship Management",
      content: "Manage customer contact information and sync with external CRM systems like Salesforce or HubSpot."
    },
    templatesTab: {
      title: "Message Templates",
      content: "Create reusable message templates for common responses. Use variables like {customerName}, {agentName}, {businessName}, {time}, {date} for personalization."
    },
    analyticsTab: {
      title: "Analytics & Insights",
      content: "Track conversation metrics, response times, customer satisfaction, and team performance over time."
    },
    usageTab: {
      title: "Usage & Billing",
      content: "Monitor your message usage against plan limits and manage subscription add-ons. Overage charges apply if limits are exceeded."
    },
    teamTab: {
      title: "Team Management",
      content: "Invite team members, assign roles (Admin or Agent), and manage permissions. Admins have full access; Agents can only manage conversations."
    },
    hoursTab: {
      title: "Business Hours",
      content: "Set when your business is available for customer conversations. Configure timezone and operating hours for accurate scheduling."
    },
    forwardingTab: {
      title: "Forwarding Rules",
      content: "Route conversations to specific phone numbers based on custom rules. Higher priority rules are evaluated first."
    },
    widgetTab: {
      title: "Chat Widget Settings",
      content: "Customize the chat widget that appears on your website. Configure appearance, position, and greeting messages."
    },
    aiKnowledgeTab: {
      title: "AI Knowledge Base",
      content: "Train your AI assistant with custom knowledge, FAQs, product information, and company policies to improve automated responses."
    },
    workflowsTab: {
      title: "Workflow Automation",
      content: "Create automated workflows that trigger based on events like new conversations, keyword matches, or status changes."
    }
  },
  appointments: {
    duration: {
      title: "Appointment Duration",
      content: "Select how long the appointment will last. The end time is automatically calculated based on your start time. Choose a preset or enter a custom duration."
    },
    reminders: {
      title: "Reminder Settings",
      content: "Choose when to send appointment reminders to customers and agents via SMS. Multiple reminders can be selected."
    },
    timezone: {
      title: "Timezone Information",
      content: "All appointment times are shown in your business timezone. Configure your timezone in Organization Settings."
    }
  },
  workflows: {
    name: {
      title: "Workflow Name",
      content: "Give this automation a descriptive name that explains what it does (e.g., 'Welcome New Customers' or 'After Hours Response')."
    },
    trigger: {
      title: "Trigger Type",
      content: "Select when this workflow should activate: New Conversation (when customer first contacts), Keyword Match (specific words detected), or Status Change (conversation state changes)."
    }
  },
  team: {
    roles: {
      title: "Role Assignment",
      content: "Admins have full access to all settings and data. Agents can view and respond to conversations but cannot access admin settings or manage other users."
    },
    phoneNumber: {
      title: "Phone Number Format",
      content: "Enter phone numbers in E.164 format: +1234567890 (country code followed by number with no spaces or dashes)."
    },
    ownRole: {
      title: "Cannot Edit Own Role",
      content: "For security, you cannot change your own role. This prevents accidental permission changes. Contact another admin to modify your role."
    }
  },
  conversation: {
    templates: {
      title: "Message Templates",
      content: "Click to insert a pre-written response template. Templates support variables that are automatically replaced with customer and agent information."
    },
    takeOver: {
      title: "Take Over Conversation",
      content: "Assign this conversation to yourself. Once taken over, you'll receive all notifications and messages will be routed to you."
    },
    aiResponse: {
      title: "AI vs Manual Response",
      content: "AI responses are automated based on your knowledge base. Manual responses are from agents. You can take over AI conversations at any time."
    }
  },
  analytics: {
    responseTime: {
      title: "Response Time",
      content: "Average time from when a customer sends a message to when an agent sends the first reply. Lower is better."
    },
    resolutionRate: {
      title: "Resolution Rate",
      content: "Percentage of conversations marked as resolved. Indicates how effectively your team solves customer issues."
    },
    peakHours: {
      title: "Peak Hours",
      content: "Times of day with the highest conversation volume. Use this to optimize agent scheduling and staffing."
    }
  },
  crm: {
    settings: {
      title: "CRM Integration",
      content: "Connect to Salesforce, HubSpot, or other CRM platforms to automatically sync contact data between systems."
    },
    contacts: {
      title: "Contact Management",
      content: "Add, edit, and organize customer contact details. Contacts are automatically created from conversations."
    }
  },
  aiSettings: {
    automation: {
      title: "AI Automation",
      content: "Configure when and how the AI should respond to customer messages. Set confidence thresholds and fallback behaviors."
    },
    knowledge: {
      title: "Knowledge Base Training",
      content: "Add FAQs, product documentation, and company policies. The AI uses this information to generate accurate responses."
    }
  }
};
